import React from 'react';
import styled, { withTheme } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import PropTypes from 'prop-types';
import { useRouter } from 'shared-routing';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';
import { token } from 'odyssey';

export const FeaturedItemWrapper = styled.div`
  position: relative;
  height: 0;
  padding-top: 67%;
`;

const FeaturedItemGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent linear-gradient(0deg, #00000065 0%, #54545419 100%) 0% 0% no-repeat
    padding-box;
`;

const SolidColorBackground = styled(FeaturedItemGradient)`
  background: ${({ theme }) => theme.customColors.tertiary};
`;

export const FeaturedItemTitle = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 15px;
  text-shadow: 0px 0px 3px #00000033;

  ${media.md`
    padding: 0 20px;
  `}

  h2 {
    margin: 0;
    padding: 20px 0;
    font-size: ${token('font-size-lg')};
    color: ${token('color-white')};
  }
`;

const FeaturedItemContent = ({ title = '', imageUrl = '', height = 250, children = null }) => (
  <BackgroundImgixWrapper src={imageUrl} customHeight="initial">
    <FeaturedItemWrapper itemHeight={height}>
      {!imageUrl && <SolidColorBackground />}
      {!!imageUrl && <FeaturedItemGradient />}
      <FeaturedItemTitle title={title}>{children}</FeaturedItemTitle>
    </FeaturedItemWrapper>
  </BackgroundImgixWrapper>
);

FeaturedItemContent.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  height: PropTypes.number,
  theme: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};

const ClickBox = styled.div`
  cursor: pointer;

  &:focus {
    outline: 0;
  }
`;

const FeaturedItem = ({
  redirectData = null,
  title = '',
  imageUrl = '',
  height = 250,
  theme,
  children = null,
}) => {
  const router = useRouter();
  if (redirectData) {
    return (
      <ClickBox
        role="button"
        tabIndex="0"
        onClick={() => router.push(redirectData)}
        aria-label={title}
      >
        <a aria-label={title}>
          <FeaturedItemContent title={title} imageUrl={imageUrl} height={height} theme={theme}>
            {children}
          </FeaturedItemContent>
        </a>
      </ClickBox>
    );
  }

  return (
    <FeaturedItemContent title={title} imageUrl={imageUrl} height={height} theme={theme}>
      {children}
    </FeaturedItemContent>
  );
};

FeaturedItem.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  height: PropTypes.number,
  theme: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
  redirectData: PropTypes.object,
};

export default withTheme(FeaturedItem);
